<script setup lang="ts">
import { APP_NAME, getPageTitle } from "@/assets/js/appConfig";
import { useDefaultStore } from "@/store";

;

const store = useDefaultStore();

useHead({
	title: getPageTitle("People - Classic Game"),
	meta: [
		{ name: "title", content: getPageTitle("People - Classic Game") },
		{
			name: "description",
			content: "Guess which person was born earlier in classic mode.",
		},
		{ name: "robots", content: "index, follow" },
		{ property: "og:title", content: getPageTitle("People - Classic Game") },
		{
			property: "og:description",
			content: "Guess which person was born earlier in classic mode.",
		},
		{ property: "og:site_name", content: APP_NAME },
	],
});
</script>

<template>
	<PeopleSinglePlayerGame
		:game-type="store.SINGLE_PLAYER_GAME_TYPES.CLASSIC_GAME"
	/>
</template>
